import React from "react";
import { Link } from "react-router-dom";
import Styles from "./newbornPricing.module.scss";

type PricingCategory = "newborn" | "baby" | "maternity" | "family";

const categories: Array<{ breadcrumbLabel: string; label: string; type: PricingCategory }> = [
  { breadcrumbLabel: "Newborn Photography Pricing", label: "Newborn", type: "newborn" },
  { breadcrumbLabel: "Baby Photography Pricing", label: "Baby", type: "baby" },
  { breadcrumbLabel: "Maternity Photography Pricing", label: "Maternity", type: "maternity" },
  { breadcrumbLabel: "Family & Event Photography Pricing", label: "Family & Events", type: "family" },
];

export const getPricingBreadcrumbSchema = (current: PricingCategory, canonicalUrl: string): object => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://alenalobacheva.com/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: categories.find((item) => item.type === current)?.breadcrumbLabel,
      item: canonicalUrl,
    },
  ],
});

export const PricingCategoryNavigation = ({ current }: { current: PricingCategory }): React.ReactElement => (
  <div className={`${Styles.pricingNavigation} ${Styles.pricingNavigation_bottom}`}>
    <nav className={Styles.pricingNavigation__categories} aria-label="Photography pricing categories">
      <span>Explore pricing</span>
      <ul>{categories.map((item) => <li key={item.type}>
        {item.type === current
          ? <span aria-current="page">{item.label}</span>
          : <Link to={`/prices/${item.type}/`}>{item.label}</Link>}
      </li>)}</ul>
    </nav>
  </div>
);

const PricingNavigation = ({ current }: { current: PricingCategory }): React.ReactElement => (
  <div className={Styles.pricingNavigation}>
    <nav aria-label="Breadcrumb">
      <ol className={Styles.pricingNavigation__breadcrumbs}>
        <li><Link to="/">Home</Link></li>
        <li>
          <span aria-current="page">{categories.find((item) => item.type === current)?.breadcrumbLabel}</span>
        </li>
      </ol>
    </nav>
  </div>
);

export default PricingNavigation;
